module.exports = __webpack_public_path__ + "img/马蜂窝_04.59444e19.jpg";